<div class="side-by-side-tabs position-relative">
    <div class="panel-title">
        Swap Device
    </div>
    <button type="button" class="close" aria-label="Close" title="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div [formGroup]="deviceSwapForm" class="change-device-dropdown">
        <div class="mt-top-2 modal-form d-flex">
            <div>
                <div>
                    <!-- <div class="d-flex">
                        <mat-form-field>
                            <mat-label>Patient Name</mat-label>
                            <input matInput formControlName="patientName">
                            <ng-container *ngIf="userSubmit && deviceSwapFormValues['patientName'].errors">
                                <mat-error *ngIf="deviceSwapFormValues['patientName'].errors?.['required']">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Patient name is required
                                </mat-error>
                            </ng-container>
                        </mat-form-field>
                        <span class="sensor-cond-style">{{condition}}</span>
                    </div> -->
                    <div class="d-grid change-device-details">
                        <div class="d-flex flex-column">
                            <div class="device-font-class mb-2">
                                <div>Patient Name :</div>
                                <span *ngIf="deviceDetails?.name">{{deviceDetails?.name}}</span>
                            </div>
                            <div class="device-font-class">
                                <div>Patient ID :</div>
                                <span *ngIf="deviceDetails?.uniqueId">{{deviceDetails?.uniqueId}}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="device-font-class mb-2">
                                <div> Sensor ID :</div>
                                <span
                                    *ngIf="deviceDetails?.device?.deviceName">{{deviceDetails?.device?.deviceName}}</span>
                                <span *ngIf="!deviceDetails?.device?.deviceName">NA</span>
                            </div>
                            <div class="device-font-class">
                                <div>Sensor Condition :</div>
                                <span class="sensor-cond-style cond-color" [ngClass]="{'sensor-cond-style-red': +data?.deviceDetails?.Battery<=20,
                                'sensor-cond-style-yellow': +data?.deviceDetails?.Battery<50 && +data?.deviceDetails?.Battery>20, 
                                    'sensor-cond-style-green': +data?.deviceDetails?.Battery>=50}"
                                    *ngIf="condition && data?.deviceDetails?.deviceId==deviceDetails?.device?._id">{{condition}}</span>
                                <span
                                    *ngIf="!condition || data?.deviceDetails?.deviceId!=deviceDetails?.device?._id">NA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex"> <button mat-raised-button color="primary" (click)="onSubmit()"
                        *ngIf="!isDeallocated" class="ml-auto">Unmap</button></div>
            </div>
            <div class="d-flex align-items-baseline">
                <mat-form-field>
                    <mat-label>Available Devices</mat-label>
                    <mat-select [disableOptionCentering]="true" formControlName="device">
                        <mat-option class="text-capitalize" *ngFor="let option of deviceList" [value]="option._id"
                            selected>
                            {{option.deviceName}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="userSubmit && deviceSwapFormValues['device'].errors">
                        <mat-error *ngIf="deviceSwapFormValues['device'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Device is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
                <button class="h-fit" mat-raised-button color="primary" (click)="onSubmit()"
                    [disabled]="!isDeallocated">Submit</button>
            </div>
        </div>
    </div>
    <!-- <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="closeModal()">Cancel</button>
    </div> -->
    <!-- <div class="red-color" style="text-align: center;">{{errorMsg}}</div> -->
</div>